// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"351":"commons","565":"component---src-templates-page-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"351":"24fc367aabd8e0d06552","565":"7b2be3ff3b9f1ffea82f","883":"b873ccc230fcec8c4c3e"}[chunkId] + ".js";
};